export const uk = {
    'auto-overdraft-sum-interval':
        'Некорректное значение порога отключения. Порог отключения должен быть в интервале от {minSum} {currency} до {maxSum} {currency}',
    'balance-unavailable-exception': 'Что-то пошло не так. Попробуйте ещё раз.',
    'bank-payment': 'Банковским переводом',
    'cannot-be-null': 'Укажите значение',
    'card-payment': 'Банковская карта',
    'general-error': 'Что-то пошло не так. Попробуйте ещё раз.',
    'no-rights-for-edit-auto-overdraft': 'Нет прав для редактирования порога отключения',
    'no-rights-for-edit-wallet': 'Нет прав для редактирования порога отключения',
    'paypal-wallet-payment': 'PayPal',
    'too-big-payment':
        'При способе оплаты «{paymentMethodName}» порог отключения не может быть ниже -{maxSum} {currency}.',
    'wallet-sum-must-be-not-null': 'Остаток на счете должен быть больше 0',
    'webmoney-wallet-payment': 'WebMoney (WMR)',
    'yamoney-wallet-payment': 'Яндекс.Деньги',
    'ynd-fixed-currency-error': 'Запрещено устанавливать значение порога отключения для выбранной валюты кошелька'
};
